import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {UPDATE_CHAT_ALERT} from "../../constants";

export function AlertSound() {

  const audio = useRef({});
  const chatID = useSelector(state => state.chat.chatID);
  const alert = useSelector(state => state.chat.alert);
  const settings = useSelector(state => state.chat.settings);
  const dispatch = useDispatch();

  useEffect(() => {
    if (alert) {
      if (!settings.notifications_disabled && alert.chat_id !== chatID) {
        audio.current.play().then(() => {
        }).catch((e) => {
          console.log('error on playing sound', e);
        });
      }
      dispatch({type: UPDATE_CHAT_ALERT, alert: null});
    }
  }, [chatID, alert, dispatch, settings]);

  return <audio hidden ref={audio}>
    <source src="/new-message.wav" type="audio/wav" />
  </audio>;
}
